export default __webpack_public_path__ + "static/media/portfolio-icon.31a21d70.svg";